import { Grid, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import { RedirectPqrListActionsProps } from './props';
import { useRedirectPqrListActions } from './hook';

export const RedirectPqrListActions = ({
    id,
    active,
    onActionComplete,
}: RedirectPqrListActionsProps) => {
    const { handleEdit, handleDelete } = useRedirectPqrListActions(
        id,
        active,
        onActionComplete
    );

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
            <Tooltip title={active ? 'Inactivar' : 'Activar'}>
                <IconButton size="small" onClick={handleDelete}>
                    {active ? (
                        <ContentPasteOffIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    ) : (
                        <ContentPasteIcon
                            type="submit"
                            sx={{ color: 'primary.main' }}
                        />
                    )}
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
